import styled from 'styled-components';

export const IconsStyled = styled.div`
  margin: 10px;
  width: calc(100% - 20px);
  display: flex;
  flex-flow: row;
  align-items: center;

  > div {
    min-width: 50px;
    flex: 1;
    display: flex;
    flex-flow: column;
    align-items: center;
    opacity: 25%;
    transition: 0.4s;
    cursor: pointer;

    > svg {
      border: 1px solid black;
      border-radius: 5px;
    }
  }
  > div:hover {
    opacity: 100%;
  }
`;